import React from "react";
import { RegisterOptions } from "react-hook-form";
import { FormItem, ColorField } from "..";
import { ColorControlProps } from "./ColorControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";
import { validateColor } from "../utils/validateUtils";

function ColorControl(props: ColorControlProps) {
  const {
    defaultValue,
    getColorFieldProps,
    hideHelperText,
    label,
    name,
    onChangeValue,
    required,
    valuePropName,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {
      validate: validateColor,
    };
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    return result;
  }, [label, required]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getColorFieldProps?.(params);
    },
    [getColorFieldProps]
  );

  return (
    <FormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      hideHelperText={hideHelperText}
      name={name}
      onChangeValue={onChangeValue}
      rules={rules}
      valuePropName={valuePropName}
    >
      <ColorField {...other} label={label} />
    </FormItem>
  );
}

export default React.memo(ColorControl);
